export class PhysicalRecipient {
  constructor (
    {
      firstName,
      lastName,
      streetLine1,
      streetLine2,
      city,
      stateOrProvince,
      postalCode,
      countryCode,
      validated
    } = {
      firstName: '',
      lastName: '',
      streetLine1: '',
      streetLine2: '',
      city: '',
      stateOrProvince: '',
      postalCode: '',
      countryCode: '',
      validated: false
    }
  ) {
    this.firstName = firstName
    this.lastName = lastName
    this.streetLine1 = streetLine1
    this.streetLine2 = streetLine2
    this.city = city
    this.stateOrProvince = stateOrProvince
    this.postalCode = postalCode
    this.countryCode = countryCode
    this.country = countryCode
    this.validated = validated
  }
}
